module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('rotate-detect'), _vm._v(" "), _c('div', {
    staticClass: "topbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "rightbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('nav-bar', {
    attrs: {
      "nav": _vm.showNav
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "artistpage"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('svg', {
    staticClass: "svg100",
    attrs: {
      "ratio": "0.25",
      "fill": "#ffffff",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 1920 480"
    }
  }, [_c('title', [_vm._v("blockwhite")]), _c('polygon', {
    attrs: {
      "points": "1920 0 0 480 0 0 1920 0"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "max1000"
  }, [_c('a', {
    staticClass: "arrow_back",
    attrs: {
      "href": "/#/?from_artist",
      "onclick": "gaclick('btn_artist_back')"
    }
  }, [_c('svg', {
    staticClass: "arrowtop",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 33.86 18.28"
    }
  }, [_c('title', [_vm._v("top")]), _c('path', {
    attrs: {
      "d": "M33.38,15.63,16,.39a1.57,1.57,0,0,0-2.58,1.15Q7.08,8.78.42,15.73c-1.33,1.38.77,3.49,2.1,2.1Q9.12,11,15.37,3.8l15.9,13.94C32.71,19,34.82,16.9,33.38,15.63Z"
    }
  })]), _vm._v(" "), _c('svg', {
    staticClass: "arrowbg",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 90.86 93.28"
    }
  }, [_c('title', [_vm._v("btn")]), _c('path', {
    attrs: {
      "d": "M0,48.67C-.06,29,12.8,9.5,31,1.79c12.47-5.27,33.3,1.68,39.81,13.45C73.66,20.35,78,24,82.3,27.59c3,2.52,4.79,5.39,4.3,9.48-.39,3.29,1,6.16,2.46,9a15.11,15.11,0,0,1,.18,14c-12.18,25.24-30,34.78-54.36,33a16,16,0,0,1-8.06-2.36C11.93,80.51,0,68.37,0,48.67Z"
    }
  })])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _c('a', {
    staticClass: "btn wow4 fadeInUp",
    attrs: {
      "href": "javascript:void(0)",
      "onclick": "trackWaitJump('btn_moreworks_wubaijun','https:/.wordpress.com/category/%E5%90%B3%E6%9F%8F%E5%9D%87/')"
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 41.24 35.64"
    }
  }, [_c('title', [_vm._v("read")]), _c('path', {
    attrs: {
      "d": "M36.64,0H23.83a4.64,4.64,0,0,0-3.2,1.33A4.64,4.64,0,0,0,17.42,0H4.6A4.67,4.67,0,0,0,0,4.6V27.83a4.67,4.67,0,0,0,4.6,4.6H17.42a1.78,1.78,0,0,1,1.8,1.8,1.4,1.4,0,0,0,1.4,1.4,1,1,0,0,0,.41-.07,1.28,1.28,0,0,0,.82-.63,1.25,1.25,0,0,0,.17-.7,1.78,1.78,0,0,1,1.8-1.8H36.64a4.67,4.67,0,0,0,4.6-4.6V4.6A4.67,4.67,0,0,0,36.64,0ZM22,4.6a1.78,1.78,0,0,1,1.8-1.8H36.64a1.78,1.78,0,0,1,1.8,1.8V27.83a1.78,1.78,0,0,1-1.8,1.8H23.83A4.18,4.18,0,0,0,22,30Zm-2.8,0V30a4.18,4.18,0,0,0-1.8-.41H4.6a1.78,1.78,0,0,1-1.8-1.8V4.6A1.78,1.78,0,0,1,4.6,2.8H17.42A1.78,1.78,0,0,1,19.22,4.6Z"
    }
  })])]), _c('span', [_vm._v("更多柏均的事")])]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "switchbtn"
  }, [_c('router-link', {
    staticClass: "btn artist9",
    attrs: {
      "to": "/artist9"
    }
  }, [_c('p', [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("藍廷瑋")])])]), _c('router-link', {
    staticClass: "btn artist2",
    attrs: {
      "to": "/artist2"
    }
  }, [_c('p', [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("林佳瑄")])])])], 1)])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookmark"
  }, [_c('img', {
    attrs: {
      "src": require("../asset/svg/bookmark/v/artist.svg"),
      "alt": "多寶創作人"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "artistdescription wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/artistpage1.svg"),
      "alt": "蒙娜麗莎對我微笑"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "artistinfo"
  }, [_c('div', {
    staticClass: "artistpic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/artist01.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "txtcontent strip"
  }, [_c('h2', {
    staticClass: "wow2 fadeInUp"
  }, [_c('span', [_vm._v("創作人/")]), _c('b', [_vm._v("吳柏均")])]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("「蒙娜麗莎的微笑是世界有名的藝術，全世界沒有人不認識達文西」「我想把蒙娜麗莎的微笑畫的跟達文西一樣好，這樣，全世界的人就會知道我，會跟我做朋友」所以畫好蒙娜麗莎的微笑，就可以有朋友，柏均這樣連結。2014年原本是單純的藝術之旅，到巴黎40\n                  天的過程，柏均企圖重建自己新的生命。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "worklist"
  }, [_c('ul', [_c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work01_1.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("蒙娜麗莎的微笑")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("80(L) × 53(M)cm (25M) 油畫 2012.")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work01_2.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("蒙娜麗莎與我一起微笑")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("91(L) x 72.5(M)cm (30F) 油畫 2011.")])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "featurepic wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/work01_3.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("一輩子畫不完")]), _vm._v(" "), _c('p', {
    staticClass: "wow3 fadeInUp"
  }, [_vm._v("65(L) x 53(M)cm (15F) 油畫 2013.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "extra"
  }, [_c('div', {
    staticClass: "txtcontent strip"
  }, [_c('h2', {
    staticClass: "wow1 fadeInUp"
  }, [_c('img', {
    attrs: {
      "src": require("../img/artist/artistpage1_1.svg"),
      "alt": "支持柏均以繪畫"
    }
  }), _c('br'), _c('img', {
    staticClass: "secondtxt",
    attrs: {
      "src": require("../img/artist/artistpage1_2.svg"),
      "alt": "自食其力的夢想"
    }
  })])]), _c('img', {
    staticClass: "wow2 fadeInUp",
    attrs: {
      "src": require("../img/artist/artist01_dream.jpg")
    }
  }), _vm._v(" "), _c('article', [_c('h5', {
    staticClass: "wow1 fadeInUp"
  }, [_vm._v("「一張畫像X一個未來」")]), _vm._v(" "), _c('p', {
    staticClass: "wow2 fadeInUp"
  }, [_vm._v("從小就欣賞寫實風格，達文西的繪畫成就一直是柏均追求的完美。"), _c('br'), _c('br'), _vm._v("「我要把人的神韻、很細微的顏色，一直一直朝著裏面看進去，"), _c('br'), _vm._v("裏面藏著很多顏色，我想把它畫出來。」"), _c('br'), _c('br'), _vm._v("他一張又一張不斷地畫人像，練習對人的觀察。"), _c('br'), _c('br'), _vm._v("柏均今年大學畢業，支持他「用畫畫工作」，開放各界朋友的委託。"), _c('br'), _vm._v("為你所愛的人畫一張人像，完成青年以藝術自食其力的夢想。"), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "entrustinfo wow3 fadeInUp"
  }, [_c('h5', [_vm._v("委託方式如下")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("尺寸")]), _vm._v("A4")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("媒材")]), _vm._v("色鉛筆")]), _vm._v(" "), _c('p', [_c('span', [_vm._v("價格")]), _vm._v("2500元/1人")])]), _vm._v(" "), _c('ul', {
    staticClass: "enterusttips wow4 fadeInUp"
  }, [_c('li', [_vm._v("提供委託畫像電子檔至"), _c('a', {
    attrs: {
      "href": "mailto:TCAA@taiwancurio.org.tw"
    }
  }, [_vm._v("多寶藝術學堂")])]), _vm._v(" "), _c('li', [_vm._v("填寫姓名、電話、地址、e-mail")]), _vm._v(" "), _c('li', [_vm._v("預付訂金1000元（或全額付清）")]), _vm._v(" "), _c('li', [_vm._v("請確認是否有交件時間的需求")]), _vm._v(" "), _c('li', [_vm._v("註：同一件作品，多一人加1500元")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12357082"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Artist1.vue
// module id = 237
// module chunks = 0